<ng-container *transloco="let t">
<address #addressComponent [showCountry]="true" [address]="residencyAddress!.address!" (addressChanged)="onAddressChanged($event)"></address>

<form #addressRelatedInfoForm="ngForm" novalidate id="addressRelatedInfoForm{{uniqueId}}" name="addressRelatedInfoForm{{uniqueId}}">
  @if (reo && residencyAddress!.residencyBasis === 'Own' && !isHidden('reo.dateAcquired')) {
    <div class="row g-9 mb-8">
      <div class="col-md-4 fv-row">
        <label class="form-label mb-2" [ngClass]="{'required': isRequired('reo.dateAcquired')}">{{ getLabel('reo.dateAcquired', t('wizard.reo.dateAcquired')) }}</label>
        <div class="position-relative d-flex align-items-center">
          <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true" autocomplete="off"
            [specialCharacters]="[ '/' ]" inputmode="numeric" [dropSpecialCharacters]="false" datePicker
            #dateAcquired="ngModel"
            [(ngModel)]="reo.dateAcquired"
            (blur)="onDateAcquiredBlur(dateAcquired)"
            placeholder="" name="dateAcquired{{uniqueId}}" id="dateAcquired{{uniqueId}}"
            [ngClass]="{'is-invalid' : dateAcquired && dateAcquired.touched && dateAcquired.invalid}"
            [required]="isRequired('reo.dateAcquired')"/>
          <div class="invalid-feedback">{{ t('wizard.reo.dateAcquiredRequired') }}</div>
        </div>
      </div>
    </div>
  }
  @if (showMoveInDate && !isHidden('residencyAddress.moveInDate')) {
    <div class="row g-9 mb-8">
      <div class="col-md-4 fv-row">
        <label class="form-label mb-2" [ngClass]="{'required': moveInDateRequired()}">{{ getLabel('residencyAddress.moveInDate', t('wizard.addressHistory.moveInDate')) }}</label>
        <div class="position-relative d-flex align-items-center">
          <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true" autocomplete="off"
            [specialCharacters]="[ '/' ]" inputmode="numeric" [dropSpecialCharacters]="false" datePicker
            #moveInDate="ngModel"
            [(ngModel)]="residencyAddress!.moveInDate"
            (blur)="onMoveInDateBlur(moveInDate)"
            placeholder="" name="moveInDate{{uniqueId}}" id="moveInDate{{uniqueId}}"
            [ngClass]="{'is-invalid' : moveInDate && moveInDate.touched && moveInDate.invalid}"
            [required]="moveInDateRequired()"/>
          <div class="invalid-feedback">{{ t('wizard.addressHistory.moveInDateRequired') }}</div>
        </div>
      </div>
    </div>
  }
  <div class="row g-9 mb-8">
    @if (!isHidden('residencyAddress.durationMonths') || !isHidden('residencyAddress.durationYears')) {
      <div class="col-md-2 fv-row" [ngClass]="{'mt-3': isMobile}" style="padding-top: 35px;">
        <label class="fs-6 fw-bold mb-2" style="margin-top: -8px">{{ t('wizard.addressHistory.howLongHere') }}</label>
      </div>
    }
    @if (!isHidden('residencyAddress.durationYears')) {
      <div class="col-md-2 fv-row" [ngClass]="{'mt-2': isMobile}">
        <label class="fs-6 fw-bold mb-2" [ngClass]="{'required': isRequired('residencyAddress.durationYears')}">{{getLabel('residencyAddress.durationYears', t('wizard.addressHistory.years'))}}</label>
        <div class="position-relative d-flex align-items-center">
          <input class="form-control form-control-solid"
            name="yearsAtAddress{{uniqueId}}"
            id="yearsAtAddress{{uniqueId}}" (blur)="onMonthsOrYearsBlurred($event)"
            [(ngModel)]="residencyAddress!.durationYears" #yearsAtAddress="ngModel" type="number" min="0"
            [readonly]="durationLocked"
            [required]="isRequired('residencyAddress.durationYears')"
            [ngClass]="{'is-invalid' : yearsAtAddress && yearsAtAddress.touched && yearsAtAddress.invalid}"/>
        </div>
      </div>
    }
    @if (!isHidden('residencyAddress.durationMonths')) {
      <div class="col-md-2 fv-row" [ngClass]="{'mt-2': isMobile}">
        <label class="fs-6 fw-bold mb-2" [ngClass]="{'required': isRequired('residencyAddress.durationMonths')}">{{getLabel('residencyAddress.durationMonths', t('wizard.addressHistory.months'))}}</label>
        <div class="position-relative d-flex align-items-center">
          <input class="form-control form-control-solid" name="monthsAtAddress{{uniqueId}}"
          id="monthsAtAddress{{uniqueId}}" (blur)="onMonthsOrYearsBlurred($event)"
          [(ngModel)]="residencyAddress!.durationMonths" type="number" min="0"
          [readonly]="durationLocked"
          [required]="isRequired('residencyAddress.durationMonths')"
          #monthsAtAddress="ngModel" [ngClass]="{'is-invalid' : monthsAtAddress && monthsAtAddress.touched && monthsAtAddress.invalid}"/>
        </div>
      </div>
    }
    @if (!isHidden('residencyAddress.residencyBasis')) {
      <div class="col-md-3 fv-row" [ngClass]="{'mt-2': isMobile}">
        <label class="fs-6 fw-bold mb-2" [ngClass]="{'required': isRequired('residencyAddress.residencyBasis')}">{{getLabel('residencyAddress.residencyBasis', t('wizard.addressHistory.ownershipStatus'))}}</label>
        <select class="form-select form-select-solid" data-control="select2" name="ownershipStatus{{uniqueId}}" id="ownershipStatus{{uniqueId}}"
          [(ngModel)]="residencyAddress!.residencyBasis" #residencyBasis="ngModel"
          (ngModelChange)="onOwnershipStatusChanged()"
          [required]="isRequired('residencyAddress.residencyBasis')"
            [ngClass]="{'is-invalid' : residencyBasis && residencyBasis.touched && residencyBasis.invalid}">
          <option [ngValue]="null">{{ t('common.selectOne') }}</option>
          <option value="Own">{{ t('wizard.addressHistory.own') }}</option>
          <option value="Rent">{{ t('wizard.addressHistory.rent') }}</option>
          <option value="LivingRentFree">{{ t('wizard.addressHistory.livingRentFree') }}</option>
        </select>
      </div>
    }
    @if (residencyAddress!.residencyBasis && residencyAddress!.residencyBasis === 'Rent' && !isHidden('residencyAddress.rent')) {
      <div class="col-md-3 fv-row" [ngClass]="{'mt-2': isMobile}">
        <label class="fs-6 fw-bold mb-2" [ngClass]="{'required': isRequired('residencyAddress.rent')}">{{getLabel('residencyAddress.rent', t('wizard.addressHistory.monthlyRent'))}}</label>
        <div class="position-relative d-flex align-items-center">
          <input class="form-control form-control-solid"
            name="monthlyPayment{{uniqueId}}"
            id="monthlyPayment{{uniqueId}}"
            #monthlyPayment="ngModel"
            [required]="isRequired('residencyAddress.rent')"
            mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            [(ngModel)]="residencyAddress!.rent"
            [ngClass]="{'is-invalid' : monthlyPayment && monthlyPayment.touched && monthlyPayment.invalid}"/>
        </div>
      </div>
    }
  </div>
</form>
</ng-container>
